document.addEventListener('DOMContentLoaded', () => {
  const topButton = document.querySelector('[data-scroll-top]');
  if (topButton) {
    const updateTopButton = () => topButton.classList.toggle('is-visible', window.scrollY > 500);
    updateTopButton();
    window.addEventListener('scroll', updateTopButton, {passive: true});
    topButton.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}));
  }

  const productButton = document.querySelector('[data-product-whatsapp]');
  const variantSelect = document.querySelector('[data-premium-product] [data-variant-select]');
  if (productButton) {
    const updateProductMessage = () => {
      const option = variantSelect?.options[variantSelect.selectedIndex];
      const sku = option?.dataset.sku || productButton.dataset.sku || '';
      const variant = option?.textContent.replace('— Tükendi', '').trim() || '';
      const parts = [`Merhaba, ${productButton.dataset.title} ürünü hakkında bilgi almak istiyorum.`];
      if (variant) parts.push(`Seçenek: ${variant}.`);
      if (sku) parts.push(`Ürün kodu: ${sku}.`);
      parts.push(productButton.dataset.url);
      productButton.href = `https://wa.me/905400421984?text=${encodeURIComponent(parts.join(' '))}`;
    };
    updateProductMessage();
    variantSelect?.addEventListener('change', updateProductMessage);
  }
});
